import React from "react";
import { ProgramContainer } from "src/entities/formTemplateDataType";

interface Props {
    programContainer: ProgramContainer;
    callbackStepIndex: (stepIndex: number) => void;
}

export class EHSPartnerPortalFooter extends React.Component<Props> {

    render() {
        const isOer = (this.props.programContainer.CategoryId || "").toLowerCase() === "oer";
        return (
            <>
                <footer className='ontario-footer ontario-footer--expanded'>
                    <div className='ontario-footer__expanded-top-section'>
                        <div className='ontario-row'>
                            <div className='ontario-columns ontario-small-12'>
                                <h2 className='ontario-h4'>Government of Ontario</h2>
                                <p>The government of Ontario includes ministries, agencies and Crown corporations.</p>
                                <p>You may contact us by email using the appropriate channels listed below:</p>
                                <p>
                                    <strong>North FO:</strong><a className="ontario-link" href='mailto:Northfieldoffice@ontario.ca'>Northfieldoffice@ontario.ca</a><br />
                                    <strong>Central East FO:</strong><a className="ontario-link" href='mailto:CentralEast@ontario.ca'>CentralEast@ontario.ca</a><br />
                                    <strong>Southwest FO:</strong><a className="ontario-link" href='mailto:Southwestfieldoffice@ontario.ca'>Southwestfieldoffice@ontario.ca</a><br />
                                    <strong>AAOU:</strong><a className="ontario-link" href='mailto:Mohaaou@ontario.ca'>Mohaaou@ontario.ca</a><br />
                                    <strong>ID Card Applications: </strong><a className="ontario-link" href="mailto:EHSCardApplications@ontario.ca">EHSCardApplications@ontario.ca</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='ontario-row ontario-footer__expanded-bottom-section'>
                        <div className='ontario-columns ontario-small-12'>
                            <ul className='ontario-footer__links-container ontario-footer__links-container--inline'>
                                <li><a className='ontario-footer__link' href={'https://www.ontario.ca/page/accessibility'}>{'Accessibility'}</a></li>
                                <li><a className='ontario-footer__link' href={'https://www.ontario.ca/page/privacy-statement'}>{'Privacy'}</a></li>
                                <li><a className='ontario-footer__link' href={'https://www.ontario.ca/feedback/contact-us'}>{'Contact us'}</a></li>
                                <li><a className='ontario-footer__link' href={'https://www.ontario.ca/page/terms-use'}>{'Terms of Use'}</a></li>
                            </ul>
                            <div className='ontario-footer__copyright'>
                                <a className='ontario-footer__link' href='https://www.ontario.ca/page/copyright-information'>{"© King's Printer for Ontario,"}
                                    <span className='ontario-nbsp'> 2012&ndash;25</span></a>
                            </div>
                        </div>
                    </div>
                </footer >
            </>
        );
    }
}

export default EHSPartnerPortalFooter;
